// utils
import { appendQueryToLink } from "../../../utils/query-string";

/** установка в window.portal настроек скачивания */
async function handleDownloadSettingsWritingToWindow() {
  const rawDownloadSettings = await fetch(appendQueryToLink(
    `/api/download-settings?_rp=${Date.now()}`,
    window.portal.utmString,
  ));
  const downloadSettings = await rawDownloadSettings.json();
  window.portal.downloadSettings = downloadSettings;
  document.dispatchEvent(new CustomEvent("download-settings-loaded"));
}

export default handleDownloadSettingsWritingToWindow;